<template>
  <div class="loading">
    <header>
      <router-link :to="{name: 'user_home'}" tag="span" class="title">hora<br> loading</router-link>
      <svg class="logo" width="100%" height="100%" viewBox="0 0 23 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">
          <g transform="matrix(0.267164,0,0,0.267164,-9.01251,-13.083)">
              <path d="M118.302,91.273L118.302,105.374L76,105.374L76,91.273L104.202,91.273L104.202,77.172L118.302,77.172L118.302,91.273ZM90.137,63.071L90.137,77.172L76.036,77.172L76.036,63.071L61.935,63.071L61.935,105.374L47.835,105.374L47.835,63.071L33.734,63.071L33.734,48.97L118.302,48.97L118.302,63.071L90.137,63.071Z"/>
          </g>
      </svg>
    </header>
  </div>
</template>

<script>
export default {
  name: 'hora'
}
</script>


<style lang="sass">
  .loading header
    padding: 0 0 0.5em
    margin: 4em
    position: fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
    justify-content: center
    animation: fade 0.5s alternate infinite

    @keyframes fade
      0%
        opacity: 0.5
      100%
        opacity: 1

    @media screen and (max-width: 768px)
      margin: 2em

    @media print
      margin: 0.5em 0

    svg.logo
      display: inline-block
      height: 2em
      align-self: center
      justify-self: center
      width: auto
      margin: 1em

    span.title
      text-transform: uppercase
      font-weight: 700
      display: inline-block
      font-size: 2em
      position: relative
      text-align: right
      margin: 0.5em

    svg.logo path
      fill: black

    span.title
      color: black
</style>